import { Link } from 'react-router-dom';
import MediaCard from '@/components/feature/MediaCard';
import type { Movie } from '@/mocks/movies';
import type { TvShow } from '@/mocks/tvshows';

interface FeaturedSectionProps {
  title: string;
  subtitle: string;
  moreLink: string;
  items: (Movie | TvShow)[];
}

export default function FeaturedSection({ title, subtitle, moreLink, items }: FeaturedSectionProps) {
  return (
    <section className="w-full px-4 md:px-8">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950 flex items-center gap-2">
            <span className="w-1 h-6 rounded-full bg-accent-500" />
            {title}
          </h2>
          <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p>
        </div>
        <Link
          to={moreLink}
          className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-accent-500 transition-colors"
        >
          查看更多
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4">
        {items.map((item) => (
          <MediaCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}